<!--
————————————————————————————————————————————————————————————————————————————————
—                                 TEMPLATE                                     —
————————————————————————————————————————————————————————————————————————————————
-->
<template>
  <div>
    <h1>{{ title }}</h1>
    <div class="form-group">
      <input v-model="msgChild1" placeholder="modifiez-moi" v-on:keyup="keyUpEvent" >
    </div>
    <p>Message (<strong>child1</strong>) : {{ msgChild1 }}</p>
    <p>Message (<strong>child2</strong>) : {{ msgChild2 }}</p>
  </div>
</template>

<!--
————————————————————————————————————————————————————————————————————————————————
—                                 SCRIPTS                                      —
————————————————————————————————————————————————————————————————————————————————
-->
<script>
import Bus from '../utils/bus.js'

export default {
  name: 'communicate-child1',
  data () {
    return {
      title: 'Child 1',
      msgChild1: 'This is message 1',
      msgChild2: ''
    }
  },
  created () {
    Bus.$emit('updateMsgChild1', this.msgChild1)
    // Intercepter event 2
    Bus.$on('updateMsgChild2', (msg) => {
      console.log('Child1 handling MsgChild2:' + msg)
      this.msgChild2 = msg
    })
  },
  mounted () {
    // Passer variable a l'initialisation au parent
    Bus.$emit('updateMsgChild1', this.msgChild1)
  },
  methods: {
    keyUpEvent: function () {
      console.log('Child1 keyUpEvent : msg1=' + this.msgChild1)
      Bus.$emit('updateMsgChild1', this.msgChild1)
    }
  }
}
</script>

<!--
————————————————————————————————————————————————————————————————————————————————
—                                  STYLES                                      —
————————————————————————————————————————————————————————————————————————————————
-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// communicate-child1.vue?828961ee